export enum AccountStatementStatus {
  Actual = "N",
  Historico = "S",
}
